const isStaging = (): boolean => {
	const host = window.location.host;
	return (
		host.includes('localhost') ||
		host.includes('.stg.atlassian') ||
		host.includes('.stg-east.frontend.public.atl-paas.net') ||
		host.includes('jira-dev.com')
	);
};

export { isStaging };
